import { Alert, Box, Button, ButtonGroup, Flex, Heading, Table, Tag, Tbody, Td, Text, Th, Thead, Tr } from '@chakra-ui/react';
import IconList from 'assets/icons/icon-list.svg?react';
import iconNote from 'assets/icons/icon-paper.svg';
import ButtonRemoveResource from 'components/ButtonRemoveResource';
import ButtonBack from 'components/ui/ButtonBack';
import ButtonCreateNew from 'components/ui/ButtonCreateNew';
import DateTime from 'components/ui/DateTime';
import DndSortableListResource, { DraggableRow, RowDragHandleButton } from 'components/ui/DndSortableList/DndSortableListResource';
import EmptyList from 'components/ui/EmptyList';
import FixedBar from 'components/ui/FixedBar';
import IconButtonEdit from 'components/ui/IconButtonEdit';
import WrapperDialog from 'components/ui/WrapperDialog';
import { wrapperDialogDefaultProps } from 'features/emails/config';
import { Link, useNavigate } from 'react-router-dom';
import { useAgendaContext } from '../contexts/AgendaContext';
import ModalConnectTopicToLists from './ModalConnectTopicToLists';
import ModalNoteTopic from './ModalNoteTopic';

interface ListNoteTopicsProps {
  note: any;
  isEditing?: boolean;
}

export default function ListNoteTopics({ note, isEditing }: ListNoteTopicsProps) {
  const navigate = useNavigate();

  const { onOpenConnectTopicToLists, onEditTopic, onCreateTopic, topicId } = useAgendaContext();

  return (
    <Box pb="100px">
      <Box>
      { topicId && <ModalConnectTopicToLists topicId={topicId} /> }
        <ModalNoteTopic />
        <Flex justifyContent="space-between" mb="25px">
          <Heading as="h1" size="h1">
            Tópicos da nota
            <span>Lista de tópicos da nota</span>

          </Heading>
          <ButtonCreateNew
            title="Novo tópico"
            onClick={onCreateTopic}
          />

        </Flex>
      { note && (
        <Alert mb="20px" status="success" variant="left-accent">
          <Text as="span">{note.title}</Text>
        </Alert>
      )}
      </Box>

      <DndSortableListResource
        resource={{
          resourceName: 'topics',
          path: 'note-topics',
          params: {
            noteId: note.id
          }
        }}
      >
      {({ sortedData: topics }) => (
        <>
        { topics.length > 0 && (
          <Table mt="30px">
            <Thead>
              <Tr>
                <Th colSpan={2}>Tópico</Th>
                <Th w="75px"></Th>
                <Th w="100px">Listas</Th>
                <Th w="100px">Criado em</Th>
                <Th w="270px"></Th>
              </Tr>
            </Thead>
            <Tbody>
            { topics?.map(topic => (
              <DraggableRow
                key={`note-topic-${topic.id}`}
                id={topic.id}
                as={Tr}
              >
                <Td w="25px">
                  <RowDragHandleButton rowId={topic.id} />
                </Td>
                <Td>
                  <Flex alignItems="center">
                    &bull;&nbsp;<Box noOfLines={1} dangerouslySetInnerHTML={{
                      __html: topic.text
                    }} />
                  </Flex>
                </Td>
                <Td>
                { topic.highlighted && <Tag colorScheme="green" mr="8px">Destaque</Tag>}
                </Td>
                <Td><Text as="span" whiteSpace="nowrap">{topic._count.lists} listas</Text></Td>
                <Td><DateTime date={topic.createdAt} /></Td>
                <Td textAlign="right">
                  <ButtonGroup>
                    <Button
                      aria-label="Listas"
                      size="sm"
                      leftIcon={<IconList />}
                      onClick={() => onOpenConnectTopicToLists(topic.id)}
                    >
                      Associar listas
                    </Button>
                    <IconButtonEdit onClick={onEditTopic(topic)} />
                    <ButtonRemoveResource
                      id={topic.id}
                      pathName="note-topics"
                      message="Você tem certeza disso? Esse tópico também será removido de todos os Disparos de Agenda que o utilizam."
                      queryKey={[
                        'topics',
                        { noteId: note.id }
                      ]}
                    />
                  </ButtonGroup>
                </Td>
              </DraggableRow>
            )) }
            </Tbody>
          </Table>
        )}

        { topics.length === 0 && (
          <EmptyList
            icon={iconNote}
            title={'Essa nota ainda não possui nenhum tópico de agenda cadastrado'}
            description={'Use o botão acima para cadastrar'}
            isTable
          />
        )}

        { !isEditing && (
          <FixedBar>
            <WrapperDialog {...wrapperDialogDefaultProps}>
              <ButtonBack
                as={Link}
                to="/notas-de-agenda"
              />
            </WrapperDialog>

            <ButtonGroup>
              <Button
                variant="primary"
                ml="auto"
                onClick={() => navigate(`/notas-de-agenda`) }
              >
                Finalizar
              </Button>
            </ButtonGroup>

          </FixedBar>
        )}
        </>
      )}
      </DndSortableListResource>
    </Box>
  )
}
